<template>

    <v-dialog :value="dialog" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
        <addProduct :dontResetSelectedItem="$props.dontResetSelectedItem"/>
    </v-dialog>

</template>

<script>
    import {ProductSettings} from '../../../store/namespace-helper'

    import addProduct from '../../Shared/AddProduct.vue'

    export default {
      name: 'add-new-products-dialog',
      components: {
        addProduct
      },
      props: {
        dontResetSelectedItem: {
          default: false,
          type: Boolean
        }
      },
      data () {
        return {}
      },
      methods: {},
      computed: {
        dialog () {
          return this.$store.getters[ProductSettings.getters.getDialogState]
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Settings/Products/AddProductDialog.vue